var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-wrapper"},[_c('div',{staticClass:"alert-box"},[(this.$root.alert_type === 1)?_c('NormalAlert'):_vm._e(),(this.$root.alert_type === 2)?_c('SubAlert'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }